import * as React from 'react';
import { FC, useId } from 'react';
import { moneyStr } from 'app/helpers/money';
import { ErrorBoundary } from 'react-error-boundary';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import useWins from './useWins';
import { Win } from './types';

const WinDetails: FC<{ win: Win; locales: Locales }> = ({ win, locales }) => {
  const id = useId();

  return (
    <div aria-labelledby={id} id="winDetails" className="win-details w-details">
      <div className="w-details_info">{translation(locales, 'jackpot_aggregator_winner_wins_info')}</div>
      <div className="w-details_wrap">
        <div className="w-details_image" />
        <div className="w-details_name" id={id}>
          {win.jackpot}
        </div>
        <div className="w-details_amount">{moneyStr(win.prize, win.currency)}</div>

        {win.url && (
          /* eslint-disable-next-line react/jsx-no-target-blank */
          <a href={win.url} className="w-details_link" target="_blank" rel="opener">
            {translation(locales, 'jackpot_aggregator_winner_wins_details')}
          </a>
        )}
      </div>
    </div>
  );
};

type JackpotAggregatorWinnerWinsProps = {
  locales: Locales;
};

const JackpotAggregatorWinnerWins: FC<JackpotAggregatorWinnerWinsProps> = ({ locales }) => {
  const [win, opened, onClick] = useWins();

  if (!win) {
    window.document.body.classList.remove('have-jackpot-notify');
    return null;
  }
  window.document.body.classList.add('have-jackpot-notify');

  return (
    <div className="jackpot-winner j-winner">
      <button type="button" onClick={onClick}>
        <span className="j-winner_text">{translation(locales, 'jackpot_aggregator_winner_wins_you_win')}</span>
        <span className="j-winner_info j-w-info">
          <span className="j-w-info_image" />
          <span className="j-w-info_name">{win.jackpot}</span>
          <span className="j-w-info_amount">{moneyStr(win.prize, win.currency)}</span>
        </span>
        <span className="j-winner_details">
          {translation(locales, 'jackpot_aggregator_winner_wins_details')}
          <span>&rang;</span>
        </span>
      </button>
      {opened && <WinDetails win={win} locales={locales} />}
    </div>
  );
};

const WrappedJackpotAggregatorWinnerWins: FC<JackpotAggregatorWinnerWinsProps> = (props) => (
  <ErrorBoundary fallback={<div className="error">Error</div>}>
    <JackpotAggregatorWinnerWins {...props} />
  </ErrorBoundary>
);

export default WrappedJackpotAggregatorWinnerWins;
